import { render, staticRenderFns } from "./RdiContainer.vue?vue&type=template&id=0aeefaf8&scoped=true"
import script from "./RdiContainer.vue?vue&type=script&lang=js"
export * from "./RdiContainer.vue?vue&type=script&lang=js"
import style0 from "./RdiContainer.vue?vue&type=style&index=0&id=0aeefaf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aeefaf8",
  null
  
)

export default component.exports